import Client from 'config/axios';
import posthog from 'posthog-js';

export const deleteSuggestedPost = async (
  token: string,
  suggestedPostId: number
) => {
  try {
    const { data } = await Client.delete(
      `suggested_post/delete/${suggestedPostId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    posthog.capture('Borrado de Propuesta de Campaña', {
      DeleteSuggestedPost: data
    });
    return { data };
  } catch (response) {
    const result = { response } as any;
    return { errors: result.data };
  }
};
